import React from 'react';
import { spinTheWheelTypes } from '@/constants/types';
import { useSelector } from 'react-redux';
import { isSpinTheWheelEnded } from '@/utils/dateTime';
import SignUpLogIn from './SignUpLogIn';
import CheckOrderStatus from './CheckOrderStatus';
import HelpAndStoreLocator from './HelpAndStoreLocator';
import SpinTheWheel from '../../SpinTheWheel/SpinTheWheel';

function MainNavTopRow({ useTranslation, onOpenLoginSignup = () => {} }) {
  const { wheelDetails, wheelList } = useSelector(
    (state) => state.spinTheWheel,
  );

  // console.log(
  //   'Is Spin End or Not',
  //   isSpinTheWheelEnded({ wheelDetails, list: wheelList }),
  // );

  return (
    <div className="hidden lg:flex justify-between items-center gap-2.5">
      {/* help and store locator */}
      <HelpAndStoreLocator />

      <div className="flex items-center gap-[24px]">
        {/* spin the wheel */}
        {!isSpinTheWheelEnded({ wheelDetails, list: wheelList }) ? (
          <SpinTheWheel type={spinTheWheelTypes.icon} />
        ) : null}

        {/* check order status modal */}
        <CheckOrderStatus useTranslation={useTranslation} />

        {/* language menu TODO: POST MVP */}
        {/* <UserInput type="dropdown" option={languageOption} /> */}

        {/* sign up and log in */}
        <SignUpLogIn onOpenLoginSignup={onOpenLoginSignup} />
      </div>
    </div>
  );
}

export default MainNavTopRow;
